import Table from "../../../../components/tables/Table";
import { ISPLCContacts } from "../types";
interface SPLCContactTableProps {
  data?: ISPLCContacts[];
}
const SPLCContactTable = ({ data }: SPLCContactTableProps) => {
  const columns = [
    {
      name: "Contact Type",
      cell: (row) => row.contactTypeName,
      sortable: true,
    },
    {
      name: "Name",
      cell: (row) => row.name,
      sortable: true,
    },
    {
      name: "Email",
      cell: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone Type",
      cell: (row) => row.phoneTypeName,
      sortable: true,
    },
    {
      name: "Phone Number",
      cell: (row) => row.contactNumber,
      sortable: true,
    },
    {
      name: "Extension Number",
      cell: (row) => row.extensionNumber,
      sortable: true,
    },
  ];
  return (
    <div className="space-y-5 mt-5">
      <Table
        columns={columns}
        data={data}
        loading={false}
        selectableRows={false}
        expandableRowsComponent={undefined}
        expandableRowExpanded={undefined}
        onSelectedRowsChange={undefined}
        clearSelectedRows={undefined}
        setOpenModal={undefined}
      />
    </div>
  );
};
export default SPLCContactTable;
